@if (items().length > 1) {
  <mwe-button
    category="secondary"
    labelKey="tariff.tariffsSelectionModal.button"
    buttonId="tariff-selections-open-modal-button"
    (clicked)="openTariffsSelectionModal(tariffsSelection)"
    [hasFullWidth]="true"
  />
} @else {
  <mwe-infobox titleKey="tariff.tariffsSelectionModal.onlyOneTariffAvailable" headingNodeType="p">
    <mwe-expander class="d-block mt-n4" [textCss]="' '" textKey="tariff.tariffsSelectionModal.onlyOneTariffAvailableAdditionalInfo" />
  </mwe-infobox>
}

<ng-template #tariffsSelection>
  <div class="px-4 px-md-5 pt-4 pt-lg-5" data-test="tariff-selection-modal">
    <div class="text-end">
      <button (click)="closeModal()" aria-label="Dialog schließen" class="btn btn-lg btn-icon btn-neutral" type="button">
        <i aria-hidden="true" class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body px-0 pt-0 pt-lg-3">
      <div class="container-xl container-wide px-0">
        <div class="row justify-content-between align-items-center mb-5 flex-wrap g-5">
          <div class="col">
            <h4 class="mb-0">
              {{ 'tariff.tariffsSelectionModal.title.' + previousTariff().category.toLowerCase() | translate: { count: items().length } }}
            </h4>
          </div>
          <div class="col-md-auto">
            @if (showTariffTypeFilter()) {
              <div class="btn-group d-flex" role="radiogroup">
                <button
                  mweButton
                  buttonId="tanke-kwh-btn"
                  [class.active]="filterKwh()"
                  [size]="'md'"
                  category="secondary"
                  color="dark-blue"
                  (clicked)="filterKwh.set(true)"
                  labelKey="charging-card.order.tariff-selection.filter.kwh"
                  role="radio"
                  [attr.aria-checked]="filterKwh()"
                ></button>
                <button
                  mweButton
                  buttonId="tanke-zeit-btn"
                  [class.active]="!filterKwh()"
                  [size]="'md'"
                  category="secondary"
                  color="dark-blue"
                  (clicked)="filterKwh.set(false)"
                  labelKey="charging-card.order.tariff-selection.filter.zeit"
                  role="radio"
                  [attr.aria-checked]="!filterKwh()"
                ></button>
              </div>
            }
          </div>
        </div>

        <mwe-horizontal-swiper [additionalOptions]="additionalSwiperOptions">
          @for (item of filteredItems(); track item.tariffKey) {
            <swiper-slide class="mt-5 h-auto">
              <mwe-tariff-selection-card-ui
                [hasActions]="true"
                [additionalOptionGroupName]="additionalOptionGroupName()"
                [tariff]="item"
                (tariffUpdated)="onTariffUpdate($event, item, cardRef)"
                (reloadAfterError)="onReloadAfterError(item, cardRef)"
                [attr.data-test]="'tariff-selection-card-' + item?.category?.toLowerCase() + '-' + item.tariffKey"
                #cardRef
              >
                <div class="text-center">
                  <mwe-button-link
                    dataTest="tariff-selection-overlay-select-{{ item.tariffKey }}"
                    label="tariff.tariffsSelectionModal.selectTariffBtn"
                    (clicked)="selectTariff(cardRef)"
                  />
                </div>
              </mwe-tariff-selection-card-ui>
              @if (
                previousTariff()?.tariffKey === item.tariffKey &&
                (previousTariff()?.anlageId === null || previousTariff()?.anlageId === item.anlageId)
              ) {
                <mwe-infobox class="d-block mt-3" messageKey="tariff.tariffsSelectionModal.currentTariff" />
              }
            </swiper-slide>
          }
        </mwe-horizontal-swiper>
      </div>
    </div>
  </div>
</ng-template>
